import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col, 
  Alert,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import { connect } from "react-redux"


const TaskLoader = props => {

  // const { id } = ;

  const [loading, setLoading] = React.useState(false);
  const [count, setCount] = React.useState('-');
  const [assets, setAssets] = React.useState([]);
  // const [resp, setResp] = React.useState('-');
  
  const [errors, setErrors] = React.useState([]);
  const [query, setQuery] = React.useState('');

  const fetchData = () => {
    setCount('-');
    setErrors([]);
    setLoading(true);
      // console.log('::ID:', props.location.state.id);
      get(url.GET_LOADER+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        // setCount(response.data);
        // setResp(JSON.stringify(response.data));
        setCount(response.count);
        setLoading(false);
      }
      else {
        setErrors(['Could not generate tasks']);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  const fetchPpmData = () => {
    setCount('-');
    setErrors([]);
    setLoading(true);
      console.log('::taskgen_ppm:');
      get(url.GET_PPM_LOADER+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        // setCount(response.data);
        // setResp(JSON.stringify(response.data));
        setCount(response.count);
        setLoading(false);
      }
      else {
        setErrors(['Could not generate tasks']);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  const clearPpmData = () => {
    setCount('-');
    setErrors([]);
    setLoading(true);
      console.log('::taskgen_ppm:');
      get(url.GET_PPM_CLEAR+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        // setCount(response.data);
        // setResp(JSON.stringify(response.data));
        // setCount(response.count);
        setLoading(false);
      }
      else {
        setErrors(['Could not clear tasks']);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  React.useEffect(()=>{
    // fetchData();
  }, []);

//   const displayed = query == '' ? assets.slice(0, 8) : assets.filter(a => a.name.toLowerCase().includes(query.toLowerCase())).slice(0, 8);

  // const searchRes = this.props.members.filter(item => item.name.toLowerCase().includes(this.state.query.toLowerCase()))


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Task Loader</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Task Loader</h3>
            {/* <Link className="btn btn-secondary" to="/forms/index">Back</Link> */}
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

              { count !== '-' &&
              <Alert color="success">
                <i className="mdi mdi-check-circle-outline me-2"></i>{count} tasks generated.
              </Alert>
              }

{/* 
              <div className="border border-danger my-5">
                {resp}
              </div>
           */}


          
            
            <Card>
                <CardBody>
                    <CardTitle tag="h3">Generate Tasks</CardTitle>
                    <p>This will erase existing tasks for today and generate new ones.</p>
                    <Button
                      color="primary"
                      className="btn btn-primary "
                      onClick={()=>{ fetchData(); }}
                      disabled={loading}
                    >
                      { loading &&
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>}
                      {" "}Generate
                    </Button>
                </CardBody>
              </Card>


            <Card>
                <CardBody>
                    <CardTitle tag="h3">Generate PPM Tasks</CardTitle>
                    <p>This will erase existing PPM tasks for today and generate new ones.</p>
                    <Button
                      color="primary"
                      className="btn btn-primary "
                      onClick={()=>{ fetchPpmData(); }}
                      disabled={loading}
                    >
                      { loading &&
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>}
                      {" "}Generate
                    </Button>
                    <Button
                      color="primary"
                      className="btn btn-danger ms-2"
                      onClick={()=>{ clearPpmData(); }}
                      disabled={loading}
                    >
                      { loading &&
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>}
                      {" "}Clear PPM test data
                    </Button>
                </CardBody>
              </Card>



        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(TaskLoader)